export const normalizePhoneNumber = (rawPhone: string): string => {
  const digitsOnly = rawPhone.replace(/[^\d+]/g, '');

  if (!digitsOnly) {
    return digitsOnly;
  }

  if (digitsOnly.startsWith('+')) {
    return digitsOnly;
  }

  if (digitsOnly.startsWith('0')) {
    return `+254${digitsOnly.substring(1)}`;
  }

  if (digitsOnly.startsWith('254')) {
    return `+${digitsOnly}`;
  }

  if (digitsOnly.startsWith('7') || digitsOnly.startsWith('1')) {
    return `+254${digitsOnly}`;
  }

  return digitsOnly;
};

